import { render, staticRenderFns } from "./rightsDetail.vue?vue&type=template&id=41ec80d2&scoped=true"
import script from "./rightsDetail.vue?vue&type=script&lang=js"
export * from "./rightsDetail.vue?vue&type=script&lang=js"
import style0 from "./rightsDetail.vue?vue&type=style&index=0&id=41ec80d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ec80d2",
  null
  
)

export default component.exports